<template>
  <PegawaiUploadForm mode="Import" module="Proyeksi Jabatan"> </PegawaiUploadForm>
</template>

<script>
import PegawaiUploadForm from './uploadForm';

const PegawaiAdd = {
  name: 'PegawaiAdd',
  components: { PegawaiUploadForm },
};

export default PegawaiAdd;
</script>
